import { render, staticRenderFns } from "./GridCapacitacion.vue?vue&type=template&id=7b70dbd2&"
import script from "./GridCapacitacion.vue?vue&type=script&lang=js&"
export * from "./GridCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports